import React from 'react';
import { Col, Row } from 'react-bootstrap';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getMotoristaColumns } from '../config/columns';

const MotoristaTable = ({
  data,
  loading,
  onRowClick,
  totalRegistros,
  paginationState,
  setPaginationState,
}) => {
  const columns = getMotoristaColumns();

  return (
    <Row>
      <Col md={12}>
        <TanStackTable
          columns={columns}
          data={data}
          onRowClick={onRowClick}
          isSortable={true}
          withPagination={true}
          manualPagination={true}
          totalItems={totalRegistros}
          onPaginationChange={setPaginationState}
          controlledPagination={paginationState}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          initialState={{
            pageIndex: paginationState?.pageIndex || 0,
            pageSize: paginationState?.pageSize || 10,
          }}
          enableRowColors={true}
          loading={!!loading}
          className="mt-3"
        />
      </Col>
    </Row>
  );
};

export default MotoristaTable;
